import React from "react";
import classnames from "classnames";
import * as actions from "../actions/actions";
import * as actionTypes from "../actions/actionTypes";
import Loading from "./loading";

import {
    WITH_ATTRIBUTION,
    NO_ATTRIBUTION,
    makeSvgKey
} from "../reducers/icons";

import cleanPreviewIcon from "../helpers/clean_svg_string";

// new imports
import { connect } from "react-redux";

class NounProjectIconView extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            imgSize: this.props.imgSize,
            ...this.setPreviewIcon(props)
        };

        if (props.selectedColor) {
            this.state = {
                ...this.state,
                ...this.setTransparentBG(props.selectedColor)
            };
        }
    }

    componentWillMount() {
        this.fetchSvg(this.props);
    }

    componentDidMount() {
        let iconImageBackground = this.setPreviewIcon(this.props);

        this.setState({
            ...this.setPreviewIcon(this.props)
        });
    }

    componentWillReceiveProps(nextProps) {
        this.setState(this.setTransparentBG(nextProps.selectedColor));
        this.fetchSvg(nextProps);

        if (
            !nextProps.loading &&
            nextProps.cachedSvg &&
            nextProps.cachedKey == this.state.fetchingSvg
        ) {
            this.setState({
                fetchingSvg: null
            });
        }

        this.setState({
            ...this.setPreviewIcon(nextProps)
        });
    }

    fetchSvg(props) {
        let attribution = props.withAttribution
            ? WITH_ATTRIBUTION
            : NO_ATTRIBUTION;
        let cachedKey = props.cachedKey;

        let shouldLoad = !props.cachedSvg || props.loading;
        let isNotAlreadyFetching = this.state.fetchingSvg !== cachedKey;
        let hasFailed =
            props.apiResponse &&
            props.apiResponse.actionType == actionTypes.FETCH_SVG_DATA_FAILURE;

        if (props.icon && shouldLoad && isNotAlreadyFetching) {
            let iconUrl = props.icon.icon_url;
            if (props.withAttribution) {
                return;
            }
            if (iconUrl) {
                this.setState({
                    fetchingSvg: cachedKey,
                    cleanedSvg: null
                });
                this.props.fetchSVGData(iconUrl, props.icon.id, attribution);
            }
        }
    }

    setTransparentBG(color) {
        return {
            transparentBG: color !== "#000000"
        };
    }

    setPreviewIcon(props) {
        let { cachedSvg, withAttribution } = props;

        let iconImageBackground;
        if (props.icon) {
            if (withAttribution) {
                iconImageBackground = props.icon.attributionPreviewUrl;
                return {
                    iconImageBackground
                };
            } else {
                iconImageBackground = props.icon.icon_url;
            }
        }
        let newState = {
            iconImageBackground
        };

        if (cachedSvg) {
            if (
                this.state &&
                this.state.cleanedSvg &&
                this.state.selectedColor == this.state.cleanedSvgColor
            ) {
                newState.iconImageBackground = this.state.cleanedSvg;
            } else {
                let newSvg = cleanPreviewIcon(
                    cachedSvg,
                    props.selectedColor,
                    !props.imgSize ? "300px" : props.imgSize
                );

                iconImageBackground =
                    "data:image/svg+xml;base64," +
                    btoa(unescape(encodeURIComponent(newSvg)));
                newState = {
                    iconImageBackground,
                    cleanedSvg: iconImageBackground,
                    cleanedSvgColor: props.selectedColor
                };
            }
        }

        return newState;
    }

    render() {
        let { imgSize, withAttribution, loading } = this.props;

        let containerStyle = {
            position: "relative",
            // maxWidth: imgSize,
            width: "100%",
            height: imgSize
        };

        if (imgSize) {
            containerStyle.minHeight = "0";
        }

        let previewIcon;

        if (
            this.props.cachedSvg ||
            (this.state.iconImageBackground && withAttribution)
        ) {
            let previewClasses = classnames("iconPreview", {
                insertIconNow: this.props.isInserting
            });

            if (this.state.iconImageBackground !== undefined) {
                let style = {
                    backgroundImage:
                        "url(" + this.state.iconImageBackground + ")"
                };

                if (!loading) {
                    previewClasses = classnames(previewClasses, {
                        "with-attribution": withAttribution,
                        "no-attribution": !withAttribution
                    });
                }

                previewIcon = <div className={previewClasses} style={style} />;
            }
        } else {
            previewIcon = <Loading />;
        }

        let iconContainerClass = classnames("the-icon-container", {
            updated: this.state.transparentBG && !!this.props.cachedSvg
        });

        return (
            <div className={iconContainerClass} style={containerStyle}>
                <div className="icon-box">{previewIcon}</div>
            </div>
        );
    }
}

function mapStateToProps(state, props) {
    let { download, apiResponse } = state;
    let icon, currentUser, selectedColor;

    if (state.user.is_anonymous !== undefined) {
        currentUser = state.user;
    }

    if (props.icon) {
        icon = props.icon;
    } else if (state.icons.active_icon) {
        icon = state.icons.active_icon;
    }

    if (icon) {
        if (props.color) {
            selectedColor = {
                hex: props.color
            };
        } else if (state.icons.selectedColor) {
            selectedColor = state.icons.selectedColor;
        }

        if (selectedColor) {
            selectedColor = selectedColor.hex;
            selectedColor = selectedColor.toUpperCase();

            if (selectedColor === "BLACK" || selectedColor === "#000") {
                selectedColor = "#000000";
            }
            if (selectedColor === "WHITE" || selectedColor === "#FFF") {
                selectedColor = "#FFFFFF";
            }
        }
    }

    let cachedSvg, cachedKey, loading;
    if (icon) {
        let { icons } = state;
        let svgKey;
        let storeIcon = icons.active_icon;

        if (!storeIcon || storeIcon.id != icon.id) {
            if (icons.featured_icons && icons.featured_icons[icon.id]) {
                storeIcon = icons.featured_icons[icon.id];
            } else if (icons[icon.id]) {
                storeIcon = icons[icon.id];
            } else {
                storeIcon = { id: icon.id };
            }
        }

        let otherKey;
        if (props.withAttribution) {
            svgKey = makeSvgKey(WITH_ATTRIBUTION);
            otherKey = makeSvgKey(NO_ATTRIBUTION);
        } else {
            svgKey = makeSvgKey(NO_ATTRIBUTION);
            otherKey = makeSvgKey(WITH_ATTRIBUTION);
        }

        cachedSvg = storeIcon[svgKey];
        cachedKey = `${storeIcon.id}-${svgKey}`;

        // Show previous SVG if cache hasn't loaded yet
        if (!cachedSvg) {
            cachedSvg = storeIcon[otherKey];
            loading = true;
        }
    }

    return {
        apiResponse,
        icon,
        cachedKey,
        cachedSvg,
        loading,
        currentUser,
        selectedColor
    };
}

export default connect(mapStateToProps, {
    fetchSVGData: actions.fetchSVGData,
    setActiveIcon: actions.setActiveIcon
})(NounProjectIconView);
